import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConnectIdentificationService } from '@shared/services/connect-identification.service';

@Component({
  selector: 'app-identification-card-item',
  templateUrl: './identification-card-item.component.html',
  styleUrls: ['./identification-card-item.component.scss']
})
export class IdentificationCardItemComponent implements OnInit {

  @Input() providerInfo: any;
  @Input() serviceType: string;
  @Input() requestDate: string;
  @Input() id: string;
  constructor(public router: Router , private connectIdentificationService: ConnectIdentificationService ) { }
  
  ngOnInit(): void { 
  }
  changeRoute(id: string, providerInfo: any, serviceType: string , requestDate: string){
    this.connectIdentificationService.sendItem(providerInfo, serviceType , requestDate);
    this.router.navigate(['identification/detail', id])
  }

}

